import React from "react";
import { Button, TextField, Grid, FormHelperText } from "@mui/material";
import PropTypes from "prop-types";
import Iconify from "../../../components/iconify";
import SurveyFormQuestionItems from "./SurveyFormQuestionItems";
import ControlledSelectSurveyType from "../../../components/form/forms/SurveyForm/ControlledSelectSurveyType";
import SurveyProtectionCheckbox from "../../../components/form/forms/SurveyForm/SurveyProtectionCheckbox";
import SurveyTargetingFields from "./SurveyTargetingFields";

CreateSurveyForm.propTypes = {
  register: PropTypes.func.isRequired,
  control: PropTypes.object.isRequired,
  fields: PropTypes.array.isRequired,
  append: PropTypes.func.isRequired,
  remove: PropTypes.func.isRequired,
  watchQuestions: PropTypes.array,
  watch: PropTypes.func.isRequired,
  errors: PropTypes.object.isRequired,
};

function CreateSurveyForm({
  register,
  control,
  fields,
  append,
  remove,
  watchQuestions,
  watch,
  errors,
}) {
  return (
    <div>
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <ControlledSelectSurveyType control={control} />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            required
            margin="normal"
            label="Titel der Befragung"
            error={!!errors.surveyTitle}
            {...register("surveyTitle", {
              required: "Dieses Feld ist erforderlich",
            })}
          />
          {errors.surveyTitle && (
            <FormHelperText error>{errors.surveyTitle.message}</FormHelperText>
          )}
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            margin="normal"
            label="Beschreibung"
            {...register("surveyDescription")}
          />
        </Grid>
        <Grid item xs={12} sx={{ mb: 2 }}>
          <SurveyProtectionCheckbox control={control} />
        </Grid>

        <SurveyTargetingFields control={control} register={register} watch={watch} />

        <SurveyFormQuestionItems
          fields={fields}
          remove={remove}
          register={register}
          watchQuestions={watchQuestions}
          control={control}
        />
        <Grid item xs={12}>
          <Button
            variant="outlined"
            onClick={() => append({})}
            startIcon={<Iconify icon="tabler:plus" />}
          >
            Frage hinzufügen
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}

export default CreateSurveyForm;
